import React from "react";

import {
    Grid,
    Paper,
    Typography,
    IconButton,
    Tooltip,
    Hidden
} from "@material-ui/core";

import {
    People,
    AccountBalanceWallet,
    ShoppingBasket,
    Settings,
    Group,
    PlaylistAddCheck,
    Edit,
    Home,
    Menu,
    ShoppingCart
} from "@material-ui/icons";

import "./MainStyle.css";
import { sto } from "../../Context/InshData";
import SwipeableNew, { dateExpire } from "./SwipeableNew";
import { local } from "../../Context/Local";
import { useHistory } from 'react-router-dom';
import i18next from "i18next";
import { useTranslation } from 'react-i18next';


const mainSystems = [
    {
        no: 0,
        id: "sales",
        title: "sales-title",
        icon: ShoppingCart,
        color: "#008000",
        background: "#edf8ed",
        description: "sales-system-description"
    },
    {
        no: 1,
        id: "purchases",
        title: "purchases-title",
        icon: ShoppingBasket,
        color: "#008b8b",
        background: "#e9f8f7",
        description: "purchases-system-description"
    },
    {
        no: 2,
        id: "safes",
        title: "stores-title",
        icon: AccountBalanceWallet,
        color: "#4b409e",
        background: "#f0effb",
        description: "stores-system-description"
    },
    {
        no: 3,
        id: "customers",
        title: "customers-and-suppliers-title",
        icon: People,
        color: "#85008f",
        background: "#faeffb",
        description: "customers-system-description"
    },
    {
        no: 4,
        id: "accounts",
        title: "accounts-title",
        icon: Edit,
        color: "#888888",
        background: "#f3f3f3",
        description: "accounts-system-description"
    },
    {
        no: 5,
        id: "basicData",
        title: "basic-information-title",
        icon: PlaylistAddCheck,
        color: "#d65e62",
        background: "#fff0f0",
        description: "basic-data-system-description"
    },
    {
        no: 6,
        id: "users",
        title: "users-and-permissions-title",
        icon: Group,
        color: "#4c84bd",
        background: "#edf5fd",
        description: "users-system-description"
    },
    {
        no: 7,
        id: "settings",
        title: "system-settings-title",
        icon: Settings,
        color: "#59c2a1",
        background: "#eaf9f3",
        description: "settings-system-description"
    }
];


export default function MainNew({
    found,
}) {
    let his = useHistory();
    const { t:transForm } = useTranslation(["forms"]);
    const {t} = useTranslation();

    const [state, setState] = React.useState({ right: false });
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };
    const handleSystemClick = (system) => {
        his.push({
            pathname: '/depts',
            state: { local: local[system.no], system:system.id,},
        })
    };


    return (
        <div className="orax-dashboard" >
            {/* =========================
          الشريط العلوي
      ========================= */}
            <header className="orax-topbar" dir={i18next.language == "ar" ? "rtl" : "ltr"}>

                <div className="orax-topbar-info">
                    <Hidden smDown={["sm"]}>
                        <div className="orax-info-item">
                            {/* <span>اسم المؤسسة</span> */}
                            <strong>{found?.nameA}</strong>
                        </div>
                    </Hidden>

                    <span className="orax-info-divider" />
                    {sto?.db_name != null && sto?.db_name !== "" &&
                        <div className="orax-info-item">
                            <span>{transForm("fiscal-year")}</span>
                            <strong>{sto?.db_label}</strong>
                        </div>
                    }
                    <span className="orax-info-divider" />

                    <div className="orax-info-item">
                        <span>{transForm("branch")}</span>
                        <strong>{sto?.branchNames}</strong>
                    </div>

                    <span className="orax-info-divider" />

                    <div className="orax-info-item">
                        <span>{transForm("user")}</span>
                        <strong>{sto?.usernames}</strong>
                    </div>

                    <span className="orax-info-divider" />
                    <div className="orax-info-item">
                        <span>{transForm("contract-start")}</span>
                        <span className="orax-info-divider" />
                        <strong style={{ color: "#00c853" }}> {"   " + found?.StartWorkDate + "   "}</strong>
                    </div>

                    <span className="orax-info-divider" />
                    <div className="orax-info-item">
                        <span>{transForm("contract-end")}</span>
                        <span className="orax-info-divider" />
                        <strong style={{ color: "#d50000" }}>{"  " + dateExpire(found?.StartWorkDate) + "  "}</strong>
                    </div>
                </div>

                <div className="orax-topbar-actions">

                    <Tooltip title={t("home")}>
                        <IconButton
                            className="orax-top-icon"
                        //   onClick={onHomeClick}
                        >
                            <Home />
                        </IconButton>
                    </Tooltip>

                </div>

            </header>


            {/* =========================
          مساحة المحتوى الرئيسية
      ========================= */}

            <main className="orax-main-content" dir={i18next.language == "ar" ? "rtl" : "ltr"}>

                <Paper
                    elevation={0}
                    className="orax-systems-panel"
                >

                    {/* عنوان اللوحة */}

                    <div className="orax-panel-header">

                        <div className="orax-panel-title">

                            <div className="orax-title-icon"
                                onClick={toggleDrawer(i18next.language == "ar" ? "right" : "left", true)}>
                                <Menu />
                            </div>

                            <div>
                                <Typography
                                    component="h1"
                                    className="orax-title-text"
                                >
                                    {transForm("main-systems")}
                                </Typography>

                                <Typography
                                    component="p"
                                    className="orax-title-subtitle"
                                >
                                    {transForm("orax-systems-subtitle")}
                                </Typography>
                            </div>

                        </div>

                        <div className="orax-panel-counter">
                            <span className="orax-counter-dot" />
                            {mainSystems.length} {transForm("systems")}
                        </div>

                    </div>


                    {/* بطاقات الأنظمة */}

                    <Grid
                        container
                        spacing={2}
                        className="orax-systems-grid"
                    >

                        {mainSystems.map((system, index) => {
                            const SystemIcon = system.icon;
                            return (

                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    key={system.id}
                                >

                                    <Paper
                                        elevation={0}
                                        className="orax-system-card"
                                        style={{
                                            "--system-color": system.color,
                                            "--system-background": system.background
                                        }}
                                        onClick={() =>
                                            handleSystemClick(system)
                                        }
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(event) => {
                                            if (
                                                event.key === "Enter" ||
                                                event.key === " "
                                            ) {
                                                event.preventDefault();
                                                handleSystemClick(system);
                                            }
                                        }}
                                    >

                                        {/* لون زخرفي في البطاقة */}

                                        <div className="orax-card-decoration" />
                                        {/* أيقونة النظام */}

                                        <div className="orax-card-icon">
                                            <SystemIcon />
                                        </div>

                                        {/* معلومات النظام */}
                                        <div className="orax-card-content">
                                            <Typography
                                                component="h2"
                                                className="orax-card-title"
                                            >
                                                {t(system.title)}
                                            </Typography>

                                            <Typography
                                                component="p"
                                                className="orax-card-description"
                                            >
                                                {transForm(system.description)}
                                            </Typography>

                                        </div>
                                        {/* سهم البطاقة */}
                                        <div className="orax-card-arrow">
                                            ‹
                                        </div>
                                    </Paper>
                                </Grid>

                            );

                        })}

                    </Grid>

                </Paper>

            </main>


            {/* =========================
          الشريط السفلي
      ========================= */}
            <div className="orax-bottom-actions" >
                <SwipeableNew found={found} state={state} setState={setState} toggleDrawer={toggleDrawer} />
            </div>

        </div>
    );
}